<template>
  <a
    class="d-activity-book grid-flex grid-no-response"
    :href="(bookUrl || book.url)"
    :rel="linkRel"
    target="_blank"
    :title="book.title"
  >
    <span class="grid-item-shrink book-cover">
      <DuiBookCover
        v-if="isExternal"
        :book-cover-url="externalBookCover"
      />
      <DuiBookCover
        v-else
        :book-cover-url="book.cover.small.url"
      />
    </span>
    <div class="grid-item">
      <div class="book-title h3">
        {{ book.title }}
      </div>
      <div>
        <span
          v-if="!!book.author"
          class="author"
        >{{ book.author }}</span>

        <DuiReviewRating
          v-if="verdict"
          :rating="verdict.rating"
          :video-review="hasVideoReview"
        />

        <span
          v-if="!isExternal"
          class="upvote-book"
        >
          <DBookVoteButton
            v-if="isUserSignedIn"
            :book-slug="book.slug"
            class="xs"
            :display-label="false"
            :is-upvoted="book.is_upvoted"
            :num-votes="book.upvotes"
          />

          <button
            v-else
            class="button-follow button-white-bordered button-xs"
            type="button"
            @click.stop.prevent="triggerSignupModal()"
          >
            <DuiIconTriangle
              class="icon-xs"
              style="margin-right: 4px;"
            />
            <span class="valign-middle">{{ book.upvotes }}</span>
          </button>
        </span>

        <!-- eslint-disable vue/no-v-html -->
        <div
          class="synopsis font-alt"
          v-html="getBookSynopsis()"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </a>
</template>

<script>
import Vue from 'vue';

import DBookVoteButton from '@d-components/d-book-vote-button/d-book-vote-button.vue';
import duiPlainText from '@dui/filters/dui-plain-text/dui-plain-text';
import duiTruncate from '@dui/filters/dui-truncate/dui-truncate';

export default {
  components: {
    DBookVoteButton,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
    bookUrl: {
      type: String,
      default: null,
    },
    hasVideoReview: {
      type: Boolean,
      default: false,
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    verdict: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    linkRel: null,
  }),
  computed: {
    externalBookCover() {
      return this.book.covers.small || this.book.covers.large;
    },
  },
  mounted() {
    this.setLinkRel();
  },
  methods: {
    getBookSynopsis() {
      return duiTruncate(duiPlainText(this.book.synopsis), 100);
    },

    setLinkRel() {
      if (!this.isExternal) {
        return;
      }

      this.$set(this, 'linkRel', 'nofollow');
    },

    triggerSignupModal() {
      if (this.isUserSignedIn) {
        return;
      }

      Vue.prototype.signupModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-activity-book {
  color: getColor($black);
  cursor: pointer;
  font-weight: normal;

  .dui-book-cover {
    height: $book-cover-height-xs;
    margin-right: $_2em;
    width: $book-cover-width-xs;

    &.square {
      height: $book-cover-width-xs;
    }
  }

  .book-title {
    word-break: break-word;
  }

  .author,
  .dui-review-rating {
    margin-right: $_1em;
  }

  .author {
    vertical-align: middle;
  }

  .synopsis {
    margin-top: $_1em;
  }
}
</style>
